import { useAsclepius } from "@/composables/api/asclepius"
import { LabOrderFacadeTypeEnum, LabOrderRequestStatusEnum } from "@vitable/asclepius-api-client-ts"
import { uselistLabOrdersFacade } from "@/composables/lab-orders-facade"

const state = () => ({
  labOrderCounts: {
    resultsReceived: 0
  },
  manualLabResultCounts: {
    unreviewed: 0
  }
})

const getters = {
  totalLabItemsNeedingAttention: (state) => {
    return state.labOrderCounts.resultsReceived + state.manualLabResultCounts.unreviewed
  },

  totalLabOrdersNeedingAttention: (state) => {
    return state.labOrderCounts.resultsReceived
  }
}

const actions = {
  refreshAllCounts({ dispatch }) {
    dispatch("getLabOrderCounts")
    dispatch("getManualLabResultCounts")
  },

  refreshLabOrderCounts({ dispatch }) {
    dispatch("getLabOrderCounts")
  },

  refreshManualLabResultCounts({ dispatch }) {
    dispatch("getManualLabResultCounts")
  },

  async getLabOrderCounts({ commit }) {
    const { labOrders, listLabOrders } = uselistLabOrdersFacade()

    try {
      await listLabOrders({
        facadeType: LabOrderFacadeTypeEnum.OrderRequest,
        status: LabOrderRequestStatusEnum.ResultsReceived
      })

      commit("setLabOrderCounts", {
        resultsReceivedCount: labOrders.total
      })
    } catch (e) {
      console.error(`Failed to getLabOrderCounts - ${e}`)
      throw new Error(e)
    }
  },

  async getManualLabResultCounts({ commit, rootGetters }) {
    if (!rootGetters["me/isClinicalAdmin"]) return
    const { getMedicalApi, callWithResponse } = useAsclepius()

    const data = await callWithResponse(() =>
      getMedicalApi().listManualLabResults({
        reviewedIn: false
      })
    )

    const unreviewedCount = data.count

    commit("setManualLabResultCounts", {
      unreviewedCount: unreviewedCount
    })
  }
}

const mutations = {
  setLabOrderCounts(state, { resultsReceivedCount }) {
    state.labOrderCounts.resultsReceived = resultsReceivedCount
  },

  setManualLabResultCounts(state, { unreviewedCount }) {
    state.manualLabResultCounts.unreviewed = unreviewedCount
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
